import React, { useState } from 'react';
import './PlanUsine.css';
import Navbar from './Navbar';
import DeviceList from './DeviceList';

const emplacementsBase = [
  'Bassin saumatre', 'Depot metallifere', 'Turbocentrale Alpha', 'Cellule de compactage', 'Reacteur Omega',
  'Zone de floculation', 'Grillage primaire', 'Neutralisation ionique', 'Forages de controle', 'Armoire electropilote',
  'Module Brava', 'Unite Luma', 'Cuisson minerale', 'Microfiltration Z1', 'Reacteur a carbonates',
  'Poste de supervision', 'Module de pressurisation', 'Generateur thermique', 'Depoussierage plasma', 'Tremie charbonnee',
  'Colonne de separation', 'Fours a induction Delta', 'Decanteur final'
];

// 🔁 Générer des top/left en grille (7 colonnes par défaut)
const genererPositions = (nColonnes = 7) => {
  const largeur = 100 / nColonnes;
  const hauteur = 100 / Math.ceil(emplacementsBase.length / nColonnes);
  return emplacementsBase.map((nom, index) => {
    const row = Math.floor(index / nColonnes);
    const col = index % nColonnes;
    return {
      id: index + 1,
      nom,
      top: `${(row + 0.5) * hauteur}%`,
      left: `${(col + 0.5) * largeur}%`
    };
  });
};

const emplacements = genererPositions();

const PlanUsine = () => {
  const [localisationSelectionnee, setLocalisationSelectionnee] = useState(null);

  const handleAfficher = (nom) => {
    setLocalisationSelectionnee(nom);
  };

  const handleRetour = () => {
    setLocalisationSelectionnee(null);
  };

  return (
    <div>
      <Navbar />
      {!localisationSelectionnee ? (
        <div className="plan-container">
          <img
            src="Planusine.png"
            alt="Plan de l'usine"
            className="plan-image"
          />
          {emplacements.map((e) => (
            <div
              key={e.id}
              className="emplacement"
              style={{ top: e.top, left: e.left, position: 'absolute' }}
              onClick={() => handleAfficher(e.nom)}
            >
              <div className="tooltip">{e.nom}</div>
            </div>
          ))}
        </div>
      ) : (
        <div>
          <button className="retourAuPlan" onClick={handleRetour}>
            Retour au plan
          </button>
          <DeviceList localisationFiltre={localisationSelectionnee} hideNavbar={true} />
        </div>
      )}
    </div>
  );
};

export default PlanUsine;
